
import React, { useEffect, useState, CSSProperties } from 'react';
import { colors } from '../colors';
import { en, es } from '../localizations';

interface Props {
  paymentMethod?: string;
  children?: any;
}

const PaymentScreen: React.FC<Props> = ({ paymentMethod, children }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function initialize() {
      const publishableKey = 1;
      if (publishableKey) {
        setLoading(false);
      }
    }
    initialize();
  }, []);

  const spinnerContainerStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const spinnerStyle: CSSProperties = {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    borderLeft: '4px solid #333',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
  };

  const containerStyle: CSSProperties = {
    flex: 1,
    backgroundColor: colors.white,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    minHeight: 0,
  };

  if (loading) {
    return (
      <div style={spinnerContainerStyle}>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        <div style={spinnerStyle}></div>
      </div>
    );
  }

  return (
    <div aria-label="payment-screen" style={containerStyle}>
      {children}
    </div>
  );
};

export default PaymentScreen;
